<template>
<div class="wrapper" :class="{'sidebar-shown': displaySidebar, 'sidebar-open': sidebarOpen}">
  <sidebar active="1" @openSidebar="sidebarOpen = true" @closeSidebar="sidebarOpen = false" @saveProgress="showSaveProgress = true"/>
  <main id="main" class="content has-sidebar">
    <app-header :back="back"></app-header>
    <header class="page">
      <h1 class="title">Planting Time</h1>
      <p class="subtitle">Select A Season</p>
    </header>
    <div class="seasons">
      <season-card
        v-for="season in seasons"
        v-bind:key="season.value"
        v-bind:season="season"
        v-bind:active="plantingTime === season.value"
        @clicked="handleSelection(season.value)"></season-card>
      <div class="season empty"><!-- empty one for space-between to work --></div>
    </div>
    <div class="button-row">
      <button class="btn btn-primary has-arrow" :disabled="!plantingTime" @click="$router.push({ name: 'goals' })">Next</button>
    </div>
  </main>
  <save-progress :shown="showSaveProgress" @close="showSaveProgress = false" />
</div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import Header from '@/components/Header'
import SeasonCard from '@/components/SeasonCard'
import SaveProgress from '@/components/SaveProgress'
export default {
  data () {
    return {
      displaySidebar: true,
      sidebarOpen: false,
      showSaveProgress: false,
      back: 'getting-started',
      seasons: [
        { className: 'is-early-mid-spring', title: 'Early - Mid Spring', subtitle: 'Soil temps near 40-50 degrees, cool growing conditions', value: 1 },
        { className: 'is-late-spring-early-summer', title: 'Late Spring - Early Summer', subtitle: 'Soil temps near 60 degrees', value: 2 },
        { className: 'is-mid-summer', title: 'Mid-Summer', subtitle: 'Warm growing conditions, 2-3 months before first frost', value: 3 },
        { className: 'is-late-summer-early-fall', title: 'Late Summer - Early Fall', subtitle: '45-60 days before first frost', value: 4 },
        { className: 'is-mid-late-fall', title: 'Mid / Late Fall', subtitle: 'Cooler weather, frost likely within 30 days of planting', value: 5 }
      ],
      plantingTime: this.$store.state.formData.plantingTime
    }
  },
  components: {
    'sidebar': Sidebar,
    'app-header': Header,
    'season-card': SeasonCard,
    'save-progress': SaveProgress
  },
  methods: {
    handleSelection (value) {
      if (this.plantingTime !== value) {
        this.$store.commit('updatePlantingTime', value)
        this.plantingTime = value
        this.$emit('resetCrops') // if we changed the selection, clear out the crops list
      }
    }
  }
}
</script>

<style lang="scss">
  .seasons {
    position: relative;
    @include media-breakpoint-up(md){
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
</style>
